"use client";

import { motion } from "framer-motion";

interface SectionSkeletonProps {
  height?: string;
}

export function SectionSkeleton({ height = "min-h-[400px]" }: SectionSkeletonProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`${height} flex items-center justify-center`}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
      </div>
    </motion.div>
  );
}
